export const capitalizeSentence = (str = '') =>
  str
    .split(' ')
    .map((word) => capitalize(word))
    .join(' ')

const capitalize = (str: string) => {
  const newStr = str.toLowerCase()
  return newStr.charAt(0).toUpperCase() + newStr.slice(1)
}

export const shortenString = (str: string, len = 45) => {
  if (str.length > len) {
    return str.slice(0, len - 1) + '...'
  }
  return str
}

export const getShortName = (fullName: string) => {
  const nameParts = fullName.trim().split(/\s+/)
  return nameParts.length > 1
    ? `${nameParts[0]} ${nameParts[nameParts.length - 1]}`
    : nameParts[0]
}

export const getGroupShortName = (fullName: string) => {
  const namePart = fullName.split(' - ')[0]

  return getShortName(namePart)
}

export const removeDiacritics = (str: string) => {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}

export const groupNameRender = (name: string, userName: string): string => {
  let filteredNames

  if (name.includes(' - ')) {
    const cleanedUserName = capitalizeSentence(removeDiacritics(userName.trim()))
    const userShortName = getGroupShortName(cleanedUserName)

    filteredNames = name
      .split(',')
      .map((n) => n.trim())
      .filter((originalChunk) => {
        const chunkShortName = getGroupShortName(
          capitalizeSentence(removeDiacritics(originalChunk)),
        )

        return chunkShortName !== userShortName
      })
  } else {
    filteredNames = name
      .split(',')
      .map((n) => getShortName(capitalizeSentence(n.trim() || '')))
      .filter((n) => n !== getShortName(capitalizeSentence(userName || '')))
  }

  return filteredNames.join(', ') || 'Nenhum usuário encontrado'
}
